export const waitUntil = (
  condition: () => boolean,
  checkInterval = 100,
  maxTime: number = 1000 * 60 * 2,
  signal?: AbortSignal
) => {
  return new Promise<void>((resolve, reject) => {
    if (signal?.aborted) {
      const error = new Error('Waiting was aborted');
      error.name = 'AbortError';
      reject(error);
      return;
    }
    if (condition()) {
      resolve();
      return;
    }

    const cleanup = () => {
      clearInterval(interval);
      clearTimeout(timeout);
      signal?.removeEventListener('abort', onAbort);
    };
    const finish = () => {
      cleanup();
      resolve();
    };
    const onAbort = () => {
      cleanup();
      const error = new Error('Waiting was aborted');
      error.name = 'AbortError';
      reject(error);
    };
    const interval = setInterval(() => {
      if (condition()) finish();
    }, checkInterval);
    const timeout = setTimeout(finish, maxTime);
    signal?.addEventListener('abort', onAbort, { once: true });
  });
};
